<template>
  <div class="entryInfoBody">
    <Header />
    <div class="entryInfoMain">
      <Step :num='2' />
      <div class="infoMainBody">
        <div class="infoArea">
          <el-form :model="infoForm" :rules="rules" ref="infoForm" label-width="100px" label-position="left">
            <el-form-item label="证件类型" prop="identType">
              <el-select :disabled="infoForm.mode == 2" v-model="infoForm.identType" placeholder="请选择证件类型" size="small" @change="setIdenType">
                <el-option v-for="item in identType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="姓名" prop="name">
              <el-input v-model="infoForm.name" size="small" placeholder="请输入姓名" maxlength="30"></el-input>
            </el-form-item>
            <el-form-item v-if="infoForm.identType == 0" label="证件号码" prop="identNo">
              <el-input :disabled="useCustomInfo" v-model="infoForm.identNo" size="small" placeholder="请输入证件号码" maxlength="18"></el-input>
            </el-form-item>
            <el-form-item v-if="infoForm.identType != 0" label="证件号码" prop="identNo">
              <el-input :disabled="useCustomInfo" v-model="infoForm.identNo" size="small" placeholder="请输入证件号码" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item v-if="infoForm.identType == 0" label="认证方式" prop="mode">
              <el-select v-model="infoForm.mode" placeholder="请选择认证方式" size="small" @change="setMode">
                <el-option v-for="item in authMode" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <p v-if="infoForm.mode==1">与银行开户预留身份信息比对验证，请确保手机号为银行卡预留手机号</p>
              <p v-if="infoForm.mode==2">根据页面提示完成指定动作后进行人脸识别，并与公安部预留人像进行 比对认证；使用此认证方式，视为您同意“豸信CA”采集您的人脸信息 用于实名认证</p>
            </el-form-item>
            <el-form-item v-if="infoForm.identType != 0" label="认证方式" prop="mode">
              <el-select v-model="infoForm.mode" placeholder="请选择认证方式" size="small" @change="setMode">
                <el-option v-for="item in authTwoMode" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <p v-if="infoForm.mode==1">与银行开户预留身份信息比对验证，请确保手机号为银行卡预留手机号</p>
            </el-form-item>
            <el-form-item v-if="infoForm.mode == 1" label="银行卡号" prop="bankCardNo">
              <el-input v-model="infoForm.bankCardNo" size="small" placeholder="请输入银行卡号" maxlength="30"></el-input>
            </el-form-item>
            <el-form-item v-if="infoForm.mode == 1|| infoForm.mode == 0" label="手机号" prop="mobile">
              <el-input v-model="infoForm.mobile" size="small" placeholder="请输入手机号" maxlength="11"></el-input>
            </el-form-item>
            <el-form-item v-if="infoForm.mode == 1 || infoForm.mode == 0" label="验证码" prop="smsCode">
              <el-input class="verificationCode" v-model="infoForm.smsCode" size="small" placeholder="请输入验证码" maxlength="6"></el-input>
              <el-button class="codeBtn" plain size="small" :disabled="countDown>0" @click="getCode">{{countDown>0?`重新获取(${countDown})`:'获取验证码'}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="lineBtn">
        <!-- <el-button size="mini" @click="getRoute">上一步</el-button> -->
        <el-button type="primary" size="mini" @click="setVerify">下一步</el-button>
      </div>
    </div>
    <!-- <scanningCode ref="scanningCode" v-show="codeShow" :codeShow="codeShow"></scanningCode> -->
    <authResult :verifyMsg="verifyMsg" :face="face" v-show="authCompletedShow" @blockAuth="getBackStep" @blockFace="blockFace"></authResult>
  </div>
</template>

<script>
import { validMobile } from '@/utils/validate'
// import scanningCode from './scanningCode.vue'
import authResult from './authResult.vue'
export default {
  name: 'entryInfo',
  data() {
    return {
      codeShow: false,
      authCompletedShow: false,
      face: false,
      verifyMsg: '',
      infoForm: {
        name: '',
        mode: null,
        identType: 0,
        identNo: null
      },
      countDown: 0,
      useCustomInfo: false,
      intervals: [],
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          // {
          //   min: 2,
          //   max: 30,
          //   pattern: /^([\u4e00-\u9fa5]|·){2,30}$/,
          //   message: '请输入正确的姓名',
          //   trigger: 'blur'
          // }
          {
            validator: this.validName,
            message: '请输入正确的姓名',
            trigger: 'blur'
          }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          {
            message: '请输入正确的手机号码',
            validator: validMobile,
            trigger: 'blur'
          }
        ],
        smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        identNo: [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
          {
            validator: this.validIDcard,
            message: '请输入正确的18位身份证号码',
            trigger: 'blur'
          }
        ],
        mode: [{ required: true, message: '请选择认证方式', trigger: 'blur' }],
        identType: [
          { required: true, message: '请选择证件类型', trigger: 'blur' }
        ],
        bankCardNo: [
          { required: true, message: '请输入银行卡号', trigger: 'blur' }
        ]
      },
      identType: [
        {
          value: 0,
          label: '中国居民身份证'
        }
        // {
        //   value: 1,
        //   label: '护照'
        // },
        // {
        //   value: 2,
        //   label: '港澳来往大陆通行证'
        // },
        // {
        //   value: 3,
        //   label: '台湾来往大陆通行证'
        // }
      ],
      authMode: [],
      authTwoMode: [
        {
          value: 1,
          label: '个人银行卡认证'
        }
      ]
    }
  },
  components: {
    // scanningCode,
    authResult
  },
  mounted() {
    this.clearInterval()
    this.getInfo()
  },
  methods: {
    blockFace() {},
    getBackStep() {
      this.countDown = 0
      this.$api
        .getBackStep({ flowId: this.$store.state.userInfo.flowId })
        .then(res => {
          if (res.code && res.code === '0') {
            this.authCompletedShow = false
            this.$refs['infoForm'].resetFields()
            this.infoForm = {
              name: '',
              mode: '0',
              identType: 0,
              identNo: ''
            }
            this.getInfo()
          } else {
            return new Promise((resolve, reject) => {
              reject(res)
            })
          }
        })
        .catch(err => {
          if (err.code === '810404') {
            this.getRoute()
            this.$alert(err.msg, '提示', {
              confirmButtonText: '好的',
              callback: () => {
                window.location.href = this.$store.state.userInfo.preWebUrl
              }
            })
          }
          this.authCompletedShow = true
          this.face = false
          this.verifyMsg = err.msg
        })
    },
    isIDcard(e) {
      const cardRule = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/
      return cardRule.test(e)
    },
    validIDcard(rule, value, callback) {
      if (rule.required && !value) {
        callback(new Error('证件号不能为空'))
      } else {
        if (this.infoForm.identType === 0) {
          if (!this.isIDcard(value) && value) {
            callback(new Error('请输入正确的证件号'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
    },
    isName(s) {
      const nameRule = /^([\u4e00-\u9fa5]|·){2,30}$/
      return nameRule.test(s)
    },
    validName(rule, value, callback) {
      if (rule.required && !value) {
        callback(new Error('请输入姓名'))
      } else {
        if (this.infoForm.identType === 0) {
          if (!this.isName(value) && value) {
            callback(new Error('请输入正确的姓名'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
    },
    setMode() {
      if (this.infoForm.mode == 0) {
        delete this.infoForm.bankCardNo
      } else if (this.infoForm.mode == 2) {
        this.infoForm.identType = 0
        delete this.infoForm.bankCardNo
        delete this.infoForm.mobile
        delete this.infoForm.smsCode
      }
    },
    setIdenType(val) {
      this.$refs.infoForm.clearValidate(['identNo'])
      this.infoForm.identNo = null
      if (val !== 0) {
        this.infoForm.mode = 1
      }
    },
    getRoute() {
      this.$router.push({ name: 'agreements' })
    },
    getInfo() {
      this.$api
        .getInfo({
          flowId: this.$store.state.userInfo.flowId
        })
        .then(res => {
          if (res.code === '0') {
            let authMode = res.data.availableAuthType.split(',')
            this.authMode = []
            this.useCustomInfo = res.data.useCustomInfo
            authMode.forEach(v => {
              if (v === 'PSN_BANK4_AUTHCODE') {
                this.authMode.push({
                  value: 1,
                  label: '个人银行卡认证'
                })
              }
              if (v === 'PSN_TELECOM_AUTHCODE') {
                this.authMode.push({
                  value: 0,
                  label: '实名手机号认证'
                })
              }
              if (v === 'PSN_FACEAUTH_BYURL') {
                this.authMode.push({
                  value: 2,
                  label: '人脸识别认证'
                })
              }
            })
            this.$set(
              this.infoForm,
              'mode',
              res.data.authType === 'PSN_TELECOM_AUTHCODE'
                ? 0
                : res.data.authType === 'PSN_BANK4_AUTHCODE'
                ? 1
                : 2
            )
            let infoData = { ...this.$store.state.userInfo }
            infoData.authMode = this.authMode
            infoData.mode = this.infoForm.mode
            this.$store.commit('SET_USERINFO', infoData)
            if (res.data.useCustomInfo) {
              this.$set(this.infoForm, 'identNo', res.data.identNo)
            }
          } else {
            return new Promise((resolve, reject) => {
              reject(res)
            })
          }
        })
        .catch(err => {
          if (err.code === '810404') {
            this.$alert(err.msg, '提示', {
              confirmButtonText: '好的',
              callback: () => {}
            })
          } else if (err.code !== '302') {
            this.$alert(err.msg, '提示', {
              confirmButtonText: '好的',
              callback: () => {}
            })
            // this.sendCode({code: -1,msg:  err.msg})
            // this.verifyMsg =  err.msg || '认证失败'
            // this.authCompletedShow = true
          }
        })
    },
    setVerify() {
      this.$refs['infoForm'].validate(valid => {
        if (valid) {
          let data = {
            indivInfo: {
              name: this.infoForm.name,
              identNo: this.infoForm.identNo,
              identType: this.infoForm.identType,
              bankcardNo: this.infoForm.bankCardNo
            },
            flowId: this.$store.state.userInfo.flowId,
            authMode: this.infoForm.mode
          }
          this.$api
            .setAuthInfo(data)
            .then(res => {
              if (res.code === '0') {
                if (this.infoForm.mode == 2) {
                  this.$router.push({ name: 'personScanningCode' })
                } else {
                  this.createVerify()
                }
              } else {
                return new Promise((resolve, reject) => {
                  reject(res)
                })
              }
            })
            .catch(err => {
              if (err.code === '810404') {
                this.$alert(err.msg, '提示', {
                  confirmButtonText: '好的',
                  callback: () => {}
                })
              } else if (err.code !== '302') {
                // this.sendCode({code: -1,msg:  err.msg})
                this.verifyMsg = err.msg || '认证失败'
                this.authCompletedShow = true
              } else {
                this.$alert(err.msg, '提示', {
                  confirmButtonText: '好的',
                  callback: () => {}
                })
              }
            })
        }
      })
      // let data = {}
    },
    createVerify() {
      this.$api
        .createVerify({
          flowId: this.$store.state.userInfo.flowId,
          mode: this.infoForm.mode,
          smsCode: this.infoForm.smsCode
        })
        .then(res => {
          if (res.code && res.code === '0') {
            this.$router.push({ name: 'authSuccess' })
          } else {
            return new Promise((resolve, reject) => {
              reject(res)
            })
          }
        })
        .catch(err => {
          if (err.code === '6006') {
            this.$alert(err.msg, '提示', {
              confirmButtonText: '好的',
              callback: () => {}
            })
          } else {
            this.authCompletedShow = true
            this.face = false
            this.verifyMsg = err.msg
          }
        })
    },
    clearInterval() {
      for (let i of this.intervals) {
        clearInterval(i)
      }
    },
    getCode() {
      this.$refs.infoForm.validateField('mobile', err => {
        if (!err) {
          this.$tencentCaptcha(val => {
            this.countDown = 60
            ;(val['mobile'] = this.infoForm.mobile),
              (val['flowId'] = this.$store.state.userInfo.flowId)
            this.$api
              .sendSmsCode(val)
              .then(res => {
                if (res.code === '0') {
                  this.infoForm.smsToken = res.data.sms_token
                  this.intervals.push(
                    setInterval(() => {
                      this.countDown--
                      if (this.countDown == 0) {
                        this.clearInterval()
                      }
                    }, 1000)
                  )
                } else {
                  return new Promise((resolve, reject) => {
                    reject(res)
                  })
                }
              })
              .catch(err => {
                this.clearInterval()
                this.countDown = 0
                this.$alert(err.msg, '提示', {
                  confirmButtonText: '好的',
                  callback: () => {}
                })
              })
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.entryInfoBody {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  background: #f1f3f7;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.entryInfoMain {
  width: 1600px;
  flex: 1;
  min-height: 620px;
  margin: 16px auto 0;
  background: #fff;
  padding: 0px 0 56px;
  position: relative;
  .lineBtn {
    width: 1600px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    border-top: 1px solid #eceef1;
    padding: 12px 0;
    text-align: center;
  }
}
.infoArea {
  width: 520px;
  margin: 51px auto 0;
  .el-input,
  .el-select {
    width: 408px;
  }
  p {
    width: 408px;
    padding: 8px 12px;
    margin-top: 12px;
    background: #f1f5ff;
    border-radius: 2px;
    font-size: 12px;
    color: #595959;
    line-height: 14px;
  }
  .verificationCode {
    width: 295px;
    margin-right: 8px;
  }
  .el-button.is-plain {
    background: #fff;
    border-color: #1c67f3;
    border-color: var(--main-bg-color);
    ::v-deep span {
      color: #1c67f3;
      color: var(--main-bg-color);
    }
    &.codeBtn.is-disabled {
      border-color: #eceff3;
      ::v-deep span {
        color: #c0c4cc !important;
      }
    }
  }
}
</style>